import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { useHistory } from 'react-router-dom';

function useManageEST() {
  const history = useHistory();
  const queryClient = useQueryClient();
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  function addEST(data) {
    return privateFetch.post(`/v1/admin/est`, data);
  }

  function updateEST(estID, data) {
    return privateFetch.put(`/v1/admin/est/${estID}`, data);
  }

  function manageEST(data = {}) {
    if (data?.id) {
      return updateEST(data.id, data);
    }

    return addEST(data);
  }

  return useMutation(manageEST, {
    onSuccess() {
      history.goBack();
    },
    onSettled() {
      queryClient.invalidateQueries('est-lists');
    },
  });
}

export default useManageEST;
